/**
 * SQL 작성 API (docs/features/26-sql-author.md) — 요구 → 유사 쿼리 → 작성 → 실행.
 *
 * 요구·유사 쿼리 찾기·실행계획 확인·부분 실행은 `/sql-author`(AI 무관), ③ AI 작성만 `/assistant/sql-author`.
 * 작업 조회·삭제에는 연결 id 를 싣지 않는다(연결이 지워져도 작업은 열린다) — 연결은 작업에 고정돼 서버가 꺼낸다.
 */
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
const ROOT = `${BASE_URL}/sql-author`;
const AI_ROOT = `${BASE_URL}/assistant/sql-author`;
const enc = encodeURIComponent;
// AI 작성은 고르기·쓰기·확인·고치기를 거듭해 길 수 있다 — 끊을 때는 signal(「중지」)
const LONG = { timeout: 12 * 60 * 1000 };

export async function listJobs(q = '') { return (await axios.get(`${ROOT}/jobs`, { params: { q } })).data; }
export async function createJob({ connectionId, title, request }) { return (await axios.post(`${ROOT}/jobs`, { connectionId, title, request })).data; }
export async function getJob(id) { return (await axios.get(`${ROOT}/jobs/${enc(id)}`)).data; }
export async function setJobConnection(id, connectionId) { return (await axios.put(`${ROOT}/jobs/${enc(id)}/connection`, { connectionId })).data; }
export async function patchJob(id, patch, { title, step } = {}) { return (await axios.put(`${ROOT}/jobs/${enc(id)}`, { patch, title, step })).data; }
export async function deleteJob(id) { return (await axios.delete(`${ROOT}/jobs/${enc(id)}`)).data; }
/** 스키마 목록 + 테이블 검색(q) 또는 스키마의 테이블 목록 */
export async function lookupCatalog({ connectionId, schema, q }) { return (await axios.post(`${ROOT}/catalog`, { connectionId, schema, q })).data; }
/** ② 유사 쿼리 — 기계 검색(DB 공유 풀 + 앱 안 자산), 값은 가려서 온다 */
export async function searchSimilar(id, q) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/similar`, { q }, { timeout: 2 * 60 * 1000 })).data; }
/** ③ 실행계획 확인 — 실행하지 않는다 */
export async function checkPlan(id, sql) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/check`, { sql })).data; }
/** ④ 부분 실행 — 위에서 maxRows 행 */
export async function runPreview(id, { sql, maxRows }) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/run`, { sql, maxRows }, { timeout: 2 * 60 * 1000 })).data; }
export async function cancelRun(id) { return (await axios.post(`${ROOT}/jobs/${enc(id)}/cancel`, {})).data; }
/** ③ AI 작성 — instruction 을 주면 지금 SQL 을 바탕으로 다시 쓴다 */
export async function aiWrite(id, { provider, instruction } = {}, signal) {
  return (await axios.post(`${AI_ROOT}/jobs/${enc(id)}/ai/write`, { provider, instruction }, { ...LONG, signal })).data;
}
